import { render, staticRenderFns } from "./Boolean.vue?vue&type=template&id=70d91335&"
import script from "./Boolean.vue?vue&type=script&lang=ts&"
export * from "./Boolean.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports